import React from "react";

import ViewInvoiceComp from "@/containers/Manager/Report/Invoices/components/ViewInvoice";

const ViewInvoice = (props) => (
  <div className="manager-billing__invoice-view">
    <div className="manager-billing__invoice-view-inner">
      <ViewInvoiceComp {...props} />
    </div>
  </div>
);

export default ViewInvoice;
